import { apiCall } from './gqlClient';
const GETEXERCISES_QUERY = "\n  query getExercises {\n    getExercises\n    {\n      id\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tmuscleArea\n\t\t\tlevel\n\t\t\timageId\n\t\t\tvideoId\n\t\t\tgifId\n\t\t\tgifThumbnailUrl\n\t\t\timageThumbnailUrl\n\t\t\tvideoThumbnailUrl\n\t\t\tmuscleTargets\n      ...fragments\n    }\n  }";
export const getExercisesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETEXERCISES_QUERY,
    variables: {},
    fragments
  });
};
const GETEXERCISESBYIDS_QUERY = "\n  query getExercisesByIds($ids: [String]!) {\n    getExercisesByIds(ids: $ids)\n    {\n      id\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tmuscleArea\n\t\t\tlevel\n\t\t\timageId\n\t\t\tvideoId\n\t\t\tgifId\n\t\t\tgifThumbnailUrl\n\t\t\timageThumbnailUrl\n\t\t\tvideoThumbnailUrl\n\t\t\tmuscleTargets\n      ...fragments\n    }\n  }";
export const getExercisesByIdsApiCall = async function (_ref) {
  let {
    ids
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETEXERCISESBYIDS_QUERY,
    variables: {
      ids
    },
    fragments
  });
};
const GETAIEXERCISES_QUERY = "\n  query getAiExercises($levels: [String]!, $muscleAreas: [String]!) {\n    getAiExercises(levels: $levels, muscleAreas: $muscleAreas)\n    {\n      id\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tmuscleArea\n\t\t\tlevel\n\t\t\timageId\n\t\t\tvideoId\n\t\t\tgifId\n\t\t\tgifThumbnailUrl\n\t\t\timageThumbnailUrl\n\t\t\tvideoThumbnailUrl\n\t\t\tmuscleTargets\n      ...fragments\n    }\n  }";
export const getAiExercisesApiCall = async function (_ref2) {
  let {
    levels,
    muscleAreas
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETAIEXERCISES_QUERY,
    variables: {
      levels,
      muscleAreas
    },
    fragments
  });
};
const SAVEEXERCISE_QUERY = "\n  mutation saveExercise($request: ExerciseInput!) {\n    saveExercise(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const saveExerciseApiCall = async function (_ref3) {
  let {
    request
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEEXERCISE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const DELETEEXERCISE_QUERY = "\n  mutation deleteExercise($id: String!) {\n    deleteExercise(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteExerciseApiCall = async function (_ref4) {
  let {
    id
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEEXERCISE_QUERY,
    variables: {
      id
    },
    fragments
  });
};